var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHomeFill = function SvgHomeFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "\\u56FE\\u5C42 1",
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M458.22 104.34c31.33-25.42 76.19-25.42 107.52 0L891.2 368.02a128.025 128.025 0 0 1 47.45 99.33V853.4c0 47.13-38.21 85.34-85.34 85.34h-128c-47.13 0-85.34-38.21-85.34-85.34V640.07c0-23.57-19.1-42.67-42.66-42.67H426.64c-23.56 0-42.67 19.1-42.67 42.67V853.4c0 47.13-38.2 85.34-85.33 85.34h-128c-47.13 0-85.33-38.21-85.33-85.34V467.43c0-38.63 17.43-75.19 47.45-99.5l325.46-263.59Z"
  })));
};
export default SvgHomeFill;